import { Map } from 'immutable'
import { AnyAction } from 'redux'
import { TURN_OFF_WEBSOCKETS } from '../actions/actionTypes'

const initialState = Map({ active: true })

export const websocket = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case TURN_OFF_WEBSOCKETS:
      return state.set('active', false)
    default:
      return state
  }
}
